import {Component, Inject, OnInit} from '@angular/core';
import {NotificationsService} from "../../services/notifications.service";
import {HttpErrorResponse} from "@angular/common/http";
import {NPA_ALERTS} from "../../consts/messages";
import {VendorTaxClearanceService} from "./vendor-tax-clearance.service";
import {TranslateService} from "../../services/translate.service";
import {IContextMenuOption} from "../context-menu/context-menu.types";
import {NPA_COMMON_DIALOG_WIDTH} from "../../consts/sizes";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {ViewDialogComponent} from "./view-dialog/view-dialog.component";
import {ItemService} from "../../../../services/item.service";
import {LogDialogComponent} from "./log-dialog/log-dialog.component";

@Component({
    selector: 'app-vendor-tax-clearance-dialog',
    templateUrl: './vendor-tax-clearance-dialog.component.html',
    styleUrls: ['./vendor-tax-clearance-dialog.component.styl']
})
export class VendorTaxClearanceDialogComponent implements OnInit {
    lang;
    data;
    contextMenuOptionHeader = [];
    contextMenuOptions: IContextMenuOption[] = [];
    showData = true;
    vendorInfo;
    tin;

    constructor(public notificationsService: NotificationsService,
                public taxClearanceService: VendorTaxClearanceService,
                private _dialog: MatDialog,
                public itemService: ItemService,
                @Inject(MAT_DIALOG_DATA) public dialogData,
                public translateService: TranslateService) {
    }

    ngOnInit() {
        this.lang = this.translateService.lang;
        this.contextMenuOptionHeader = [];
        this.contextMenuOptions = [
            {
                title: 'COMMON.VIEW',
                action: (options: any) => {
                    this.openViewDialog(options);
                },
                pipeTranslate: true,
                disabled: (options: any) => {
                    return this.notificationsService.isLoading
                },
            },
            {
                title: 'COMMON.LOG',
                action: (options: any) => {
                    this.openLogDialog(options);
                },
                pipeTranslate: true,
                disabled: (options: any) => {
                    return this.notificationsService.isLoading
                },
            }
        ];
        this.notificationsService.startLoading();
        this.taxClearanceService.showVendor(this.dialogData.username).subscribe((showData) => {
            this.vendorInfo = showData;
            this.tin = (this.vendorInfo && (this.vendorInfo.tin)) ? this.vendorInfo.tin : '';
            if (this.tin.toString().length > 5) {
                this.taxClearanceService.index(this.tin).subscribe((data) => {
                    this.data = data;
                    this.showData = true;
                    this.notificationsService.dismissLoading();
                }, (error: HttpErrorResponse) => {
                    if (error.status === 404) {
                        this.showData = false;
                        this.notificationsService.info(NPA_ALERTS[this.lang].NO_SIGTAS_DATA);
                        this.notificationsService.dismissLoading();
                    } else {
                        this.notificationsService.dismissLoading();
                        this.notificationsService.error(NPA_ALERTS[this.lang].ERROR);
                    }
                    console.error(error);
                });
            } else {
                this.notificationsService.dismissLoading();
            }
        }, (error: HttpErrorResponse) => {
            this.notificationsService.error(NPA_ALERTS[this.lang].ERROR);
            console.error(error);
        });
    }

    refresh() {
        this.ngOnInit();
    }

    openViewDialog(data) {
        if (data && !data.tin) {
            data.tin = this.tin
        }
        this._dialog.open(ViewDialogComponent, {
            data: data,
            disableClose: true,
        });
    }

    openLogDialog(data) {
        if (data && !data.tin) {
            data.tin = this.tin
        }
        this._dialog.open(LogDialogComponent, {
            data: data,
            width: NPA_COMMON_DIALOG_WIDTH,
            disableClose: true,
        });
    }

}
